var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationMarkRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 0.332031H2.33332C1.41666 0.332031 0.67499 1.08203 0.67499 1.9987L0.666656 11.9987C0.666656 12.9154 1.41666 13.6654 2.33332 13.6654H8.99999V11.9987H2.33332V3.66536L8.99999 7.83203L15.6667 3.66536V7.83203H17.3333V1.9987C17.3333 1.08203 16.5833 0.332031 15.6667 0.332031ZM8.99999 6.16536L2.33332 1.9987H15.6667L8.99999 6.16536ZM13.45 15.332L10.5 12.382L11.675 11.207L13.4417 12.9737L16.975 9.44036L18.1667 10.6154L13.45 15.332Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMarkRead);
export default __webpack_public_path__ + "static/media/NotificationMarkRead.9d4b4b65.svg";
export { ForwardRef as ReactComponent };